// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Styling */
body {
  margin: 0;
  font-family: Arial, sans-serif;
}

.profile-page {
  padding: 0; /* Remove padding to avoid spacing issues with the header bar */
  min-height: 100vh;
  display: flex;
  width: 100%;
  flex-direction: column;
  background-color: #f9f9f9;
}

.profile-page.dark {
  background-color: #333;
  color: #fff;
}

/* Header Bar */
.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #ffffff; /* Light theme background */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  position: sticky;
  top: 0;
  z-index: 10;
}

.profile-page.dark .top-bar {
  background-color: #444; /* Dark theme background */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5); /* More prominent shadow for dark mode */
}

.back-button {
  font-size: 16px;
  color: #420cd2;
  background: none;
  border: none;
  cursor: pointer;
}

.profile-page.dark .back-button {
  color: #ffffff; /* Neutral white in dark mode */
}

.back-button:hover {
  color: #720cd2;
}

.notification-icon {
  font-size: 24px;
  cursor: pointer;
  color: #420cd2;
}

.profile-page.dark .notification-icon {
  color: #ffffff; /* Neutral white in dark mode */
}

.notification-icon:hover {
  color: #720cd2;
}

.top-heading {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  color: #420cd2;
  flex: 1 1;
}

.profile-page.dark .top-heading {
  color: #ffffff; /* Neutral white in dark mode */
}

/* Profile Section */
.profile-section {
  text-align: center;
  margin-bottom: 30px;
  margin-top: 50px; /* Add gap between header and profile image */
}

.profile-img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.profile-initials {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #555;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin: 0 auto;
}
h1{
  margin-top: 10px;
  margin-right: 40px;
}
h2 {
  margin: 10px 0 5px;
}

p {
  color: #777;
}

/* Account Settings Section */
.account-settings {
  margin: 20px;
  padding: 20px;
  background: #f1f1f1;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.profile-page.dark .account-settings {
  background: #444;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
}

h3 {
  margin-bottom: 15px;
  font-size: 20px;
}

.setting-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

/* Account Permissions Dropdown */
select {
  padding: 5px;
  font-size: 16px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

/* Custom Toggle */
.icon-toggle {
  width: 70px;
  height: 30px;
  background-color: #ddd;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition: background-color 0.3s ease;
}

.icon-toggle.light {
  background-color: #fff; /* Sun (light mode) */
}

.icon-toggle.dark {
  background-color: #4a47a3; /* Moon (dark mode) */
}

.toggle-icon {
  height: 26px;
  width: 26px;
  background-color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;
}

.icon-toggle.light .toggle-icon {
  transform: translateX(-20px);
}

.icon-toggle.dark .toggle-icon {
  transform: translateX(20px);
}

.toggle-icon i {
  font-size: 14px;
  color: #420cd2;
}

/* Logout Button */
.logout-container {
  margin-top: auto;
  display: flex;
  justify-content: center; /* Center the button horizontally */
}

.logout-btn {
  width: 200px; /* Reduce width */
  padding: 10px;
  font-size: 16px;
  color: white;
  background-color: #840cd2;
  border: none;
  margin-bottom: 50px;
  border-radius: 5px;
  cursor: pointer;
}

.logout-btn:hover {
  background-color: #840cd2;
}


@media (max-width: 480px) {
  .admin-option {
    display: none;
    pointer-events: none; /* Disable interaction */
    color: #ccc; /* Change color to indicate it's disabled */
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ProfilePage.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,UAAU,EAAE,+DAA+D;EAC3E,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB,EAAE,2BAA2B;EACtD,wCAAwC,EAAE,kBAAkB;EAC5D,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,sBAAsB,EAAE,0BAA0B;EAClD,wCAAwC,EAAE,wCAAwC;AACpF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc,EAAE,+BAA+B;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc,EAAE,+BAA+B;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,cAAc,EAAE,+BAA+B;AACjD;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB,EAAE,6CAA6C;AACjE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB,EAAE,qBAAqB;AAC/C;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;AAClD;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB,EAAE,mCAAmC;AAC9D;;AAEA;EACE,YAAY,EAAE,iBAAiB;EAC/B,aAAa;EACb,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE;IACE,aAAa;IACb,oBAAoB,EAAE,wBAAwB;IAC9C,WAAW,EAAE,2CAA2C;EAC1D;AACF","sourcesContent":["/* General Styling */\nbody {\n  margin: 0;\n  font-family: Arial, sans-serif;\n}\n\n.profile-page {\n  padding: 0; /* Remove padding to avoid spacing issues with the header bar */\n  min-height: 100vh;\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  background-color: #f9f9f9;\n}\n\n.profile-page.dark {\n  background-color: #333;\n  color: #fff;\n}\n\n/* Header Bar */\n.top-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 20px;\n  background-color: #ffffff; /* Light theme background */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Subtle shadow */\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.profile-page.dark .top-bar {\n  background-color: #444; /* Dark theme background */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5); /* More prominent shadow for dark mode */\n}\n\n.back-button {\n  font-size: 16px;\n  color: #420cd2;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.profile-page.dark .back-button {\n  color: #ffffff; /* Neutral white in dark mode */\n}\n\n.back-button:hover {\n  color: #720cd2;\n}\n\n.notification-icon {\n  font-size: 24px;\n  cursor: pointer;\n  color: #420cd2;\n}\n\n.profile-page.dark .notification-icon {\n  color: #ffffff; /* Neutral white in dark mode */\n}\n\n.notification-icon:hover {\n  color: #720cd2;\n}\n\n.top-heading {\n  font-size: 18px;\n  font-weight: bold;\n  text-align: center;\n  color: #420cd2;\n  flex: 1;\n}\n\n.profile-page.dark .top-heading {\n  color: #ffffff; /* Neutral white in dark mode */\n}\n\n/* Profile Section */\n.profile-section {\n  text-align: center;\n  margin-bottom: 30px;\n  margin-top: 50px; /* Add gap between header and profile image */\n}\n\n.profile-img {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n}\n\n.profile-initials {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background-color: #555;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  margin: 0 auto;\n}\nh1{\n  margin-top: 10px;\n  margin-right: 40px;\n}\nh2 {\n  margin: 10px 0 5px;\n}\n\np {\n  color: #777;\n}\n\n/* Account Settings Section */\n.account-settings {\n  margin: 20px;\n  padding: 20px;\n  background: #f1f1f1;\n  border-radius: 10px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.profile-page.dark .account-settings {\n  background: #444;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);\n}\n\nh3 {\n  margin-bottom: 15px;\n  font-size: 20px;\n}\n\n.setting-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n/* Account Permissions Dropdown */\nselect {\n  padding: 5px;\n  font-size: 16px;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n}\n\n/* Custom Toggle */\n.icon-toggle {\n  width: 70px;\n  height: 30px;\n  background-color: #ddd;\n  border-radius: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n  transition: background-color 0.3s ease;\n}\n\n.icon-toggle.light {\n  background-color: #fff; /* Sun (light mode) */\n}\n\n.icon-toggle.dark {\n  background-color: #4a47a3; /* Moon (dark mode) */\n}\n\n.toggle-icon {\n  height: 26px;\n  width: 26px;\n  background-color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n  transition: transform 0.3s ease;\n}\n\n.icon-toggle.light .toggle-icon {\n  transform: translateX(-20px);\n}\n\n.icon-toggle.dark .toggle-icon {\n  transform: translateX(20px);\n}\n\n.toggle-icon i {\n  font-size: 14px;\n  color: #420cd2;\n}\n\n/* Logout Button */\n.logout-container {\n  margin-top: auto;\n  display: flex;\n  justify-content: center; /* Center the button horizontally */\n}\n\n.logout-btn {\n  width: 200px; /* Reduce width */\n  padding: 10px;\n  font-size: 16px;\n  color: white;\n  background-color: #840cd2;\n  border: none;\n  margin-bottom: 50px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.logout-btn:hover {\n  background-color: #840cd2;\n}\n\n\n@media (max-width: 480px) {\n  .admin-option {\n    display: none;\n    pointer-events: none; /* Disable interaction */\n    color: #ccc; /* Change color to indicate it's disabled */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
